import { useCallback, useState } from 'react';
import { DormitoryHttp } from '@/services';
import { parseError } from '@/utils';

export default function useUserDormitory() {

  const [dormitory, setDormitory] = useState<UserDormitoryEntity>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  const fetchUserDormitory = useCallback(async () => {
    try {
      setError(null);
      setLoading(true);
      const data = await DormitoryHttp.fetchUserDormitory();
      const dorm = data?.payload;
      if ((!dorm || Object.keys(dorm).length === 0)) {
        return setDormitory(null);
      }
      setDormitory(dorm);
    }
    catch (e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { dormitory, fetchUserDormitory, error, loading };
}
